import { render, staticRenderFns } from "./MyCompanyUsersNew.vue?vue&type=template&id=23c5acc7&"
import script from "./MyCompanyUsersNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyUsersNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports